import React from 'react';
import {FaCalendar, FaMoneyCheck} from "react-icons/fa";
import {FaListCheck} from "react-icons/fa6";
import DivisorItem from "./divisor-item.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";

const EncounterDetails = ({data}) => {
    const navigate = navigateHook();

    const open = () => {
        const urlDev = `/encounter/form/${data.id}`
        navigate(urlDev, true);
    }

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#287499] mb-0`}>Abordagem</p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data"} value={projectUtils.formatDate(data.date)}/>
                <DivisorItem icon={<FaMoneyCheck size={18}/>} text={"Justificativa"} value={data.observation}/>
                <DivisorItem icon={<FaListCheck size={18}/>} text={"Ações decorrentes"} value={data.actions}/>

                <Button onClick={open}>
                    Abrir cadastro
                </Button>
            </div>
        </>
    );
};

export default EncounterDetails;